export default __webpack_public_path__ + "static/media/TRANSPORTS en COMMUN.4977c46a.svg";